import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SettingsService } from '../.services/settings.service';
import { ConnectionService } from '../.services/connection.service';
import { ChatService } from '../.services/chat.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-chat',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})

export class ChatComponent implements OnInit {

  connection: ConnectionService;
  settings: SettingsService;
  cService: ChatService;
  messages:Array <any> = [];
  inputText: string = "";
  chatLocked: boolean;
  isHost: boolean;
  activeChat: any;
  chats:Array<any> = [];
  activeTab: any;

  
  
 
 
  

  setActiveChat = (tab) => {
    let name = tab.target.innerText;
    this.activeTab = tab.target;
   
    
    let chat = this.cService.findChatInChatList(name)
      .then(chat => {
        console.log(chat)
        this.activeChat = chat;
        console.log('settng active chat to ')
        console.log(this.activeChat);
     });
 

    this.cService.clearTabHighlights(name);
  }

  toggleLock = () => {
    if(this.connection.checkIsHost()){
      let userId = this.settings.getId();
      this.chatLocked = !this.chatLocked;
      this.connection.connection.sendCustomMessage({type: 'disableChat', msg: {from: userId, set: this.chatLocked}});
    }
  }

  addMessageToActiveChat = (message) => {
    this.activeChat.messages.push({from: "You", message: message});
  }

  changeDetectionHack = () => {
    let chatTab: HTMLElement = document.getElementsByClassName('tabs-title')[0] as HTMLElement;
    let previousTab = this.activeTab;
        chatTab.click(); 
        previousTab.click();
       

    
  }

  sendMessage = (e) => {
    if(e.keyCode == 13) {
      if(this.inputText != "" && this.inputText != "undefined") { 
        this.addMessageToActiveChat(this.inputText);
        this.connection.connection.sendCustomMessage({type: 'chatMessage', msg: { to: this.activeChat.name, from: this.settings.getUsername(), message: this.inputText}});
        this.inputText = "";
        this.changeDetectionHack();
      }
    }
  }

 
constructor(private connectionService: ConnectionService, private settingsService: SettingsService, private chatService: ChatService ) { 
    this.connection = connectionService;
    this.settings = settingsService;
    this.cService = chatService;
    this.inputText = "";
  }

  ngOnInit() {
      this.connection.cast.subscribe((setting) => {
        this.isHost = setting;
      });

      this.settings.chatLockCast.subscribe((setting) => {
        this.chatLocked = setting;
      });

      
      this.cService.chatListCast.subscribe((list)=> {
        this.chats = list;
      });

      this.connection.incomingMessageCast.subscribe((message) => {
        if(message) {
          this.cService.addMessage(message.to, message.from, message.message);
        }
      });

      this.activeChat = this.chats[0];
      this.cService.updateTabNames();
      
      

  }

}
